// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"49431ea0","361":"a868dd98","574":"8b0d2455","583":"ceb1457b","661":"2c3aaba0","760":"8f8f6b31","911":"46ca1dbc"}[chunkId] + ".chunk.js";
};